import React, {useRef} from 'react'
import { Field, reduxForm } from 'redux-form'
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField'
import RadioGroup from '@material-ui/core/RadioGroup'
import Checkbox from '@material-ui/core/Checkbox'
import Select from '@material-ui/core/Select'
import UploadButton from './UploadButton'
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormHelperText from '@material-ui/core/FormHelperText';
import ReactQuill from 'react-quill';
import Typography from '@material-ui/core/Typography';
import Rating from '@material-ui/lab/Rating';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    width: '100%',
    marginTop: '6px !important',
  },
  input: {
    width: '100%'
  },
  formControlTall: {
    width: '100%',
    marginTop: '6px !important',
    paddingTop: '18px !important',
  }
}));

export const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    label={label}
    error={typeof(touched && error) == 'string'}
    helperText={touched && error}
    {...input}
    {...custom}
  />
)

export const renderTextFieldCompact= ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  const classes = useStyles();

  let labelRef = useRef(null); // we use label height to use two lines class
  let className = (labelRef.current && (labelRef.current.clientHeight > 20)) ? classes.formControlTall  : classes.formControl;

  return (<TextField
    className={className}
    label={label}
    InputProps={{ className: classes.inputCompact }}
    InputLabelProps={{ref: labelRef}}
    error={typeof(touched && error) == 'string'}
    helperText={touched && error}
    {...input}
    {...custom}
  />)
};

export const renderRatingField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <div>
    <Typography>{label}</Typography>
    <Rating
      name={input.name}
      {...input}
      {...custom}
    />
  </div>
)

export const renderUploadButton = ({
  input,
  label,
  ...custom
}) => (
  <UploadButton label={label} {...input} {...custom} >
    {label}
  </UploadButton>
)

export const renderCheckbox = ({ input, label }) => (
  <Checkbox
    label={label}
    checked={input.value ? true : false}
    onCheck={input.onChange}
  />
)

// Render label and uses options hash, for example { true: 'Yes', false: 'No }
export const renderSwitch = ({ input, label, options, ...rest }) => (
  <>
  <FormHelperText>{label}</FormHelperText>
  <FormControlLabel
    control={
    <Switch
      checked={input.value ? true : false}
      onChange={input.onChange}
      name={input.name}
      color="primary"
    />
    }
  label={options[input.value ? true : false]}
  />
  </>
)

export const renderRadioGroup = ({ input, ...rest }) => (
  <RadioGroup
    {...input}
    {...rest}
    valueSelected={input.value}
    onChange={(event, value) => input.onChange(value)}
  />
)

export const renderSelectFieldCompact = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  const classes = useStyles();

  let labelRef = useRef(null); // we use label height to use two lines class
  let className = (labelRef.current && (labelRef.current.clientHeight > 20)) ? classes.formControlTall  : classes.formControl;

  return (<FormControl className={className}>
    <InputLabel ref={labelRef} id={`${input.name}_label`}>{label}</InputLabel>
    <Select
      className={classes.inputCompact}
      labelId={`${input.name}_label`}
      id={input.name}
      error={touched && error}
      {...input}
      onChange={(event) => input.onChange(event.target.value)}
      children={children}
      {...custom}
    />
  </FormControl>);
  }

export const renderSelectField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  const classes = useStyles();
  return (<FormControl className={classes.formControl}>
    <InputLabel id={`${input.name}_label`}>{label}</InputLabel>
    <Select
      labelId={`${input.name}_label`}
      id={input.name}
      error={touched && error}
      {...input}
      onChange={(event) => input.onChange(event.target.value)}
      children={children}
      {...custom}
    />
  </FormControl>);
  }


export const renderRichtextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  const handleChange = (value, delta, source, editor) => {
    input.onChange(editor.getHTML());
  };
  return (
  <ReactQuill modules={{clipboard: { matchVisual: false }}} placeholder={label} style={{minHeight: 300}} theme="snow" value={input.value} onChange={input.onChange}>
    <Typography gutterBottom variant='body1' style={{minHeight: 250}}></Typography>
  </ReactQuill>
); }
